module.exports = __webpack_public_path__ + "img/tjt_up.bae89b62.png";